export class AppConstant {
    static authToken: string = 'auth_token';
    static authName: string = 'auth_name';
    static urlPatten:any =/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
    static dateFormat: string = 'MM/DD/YYYY';
}
